<template>
  <div class="container flex">
    <!-- <div class="container-list"> -->
    <div id="test" class="flex ml10 mt10">
      <div class="leftnav mt10" style="width: 25%; height: 91%">
        <div style="width: 100%" class="center">
          <!-- <el-col :span="24">
                <el-input
                  placeholder="请输入部位号或名称搜索"
                  clearable
                  v-model="rightParams.true_addr"
                  prefix-icon="el-icon-search"
                ></el-input>
              </el-col> -->
          <!-- <el-col :span="5">
                <el-button
                  type="primary"
                  class="ml10"
                  style="margin-top: 0px"
                  size="small"
                  @click="searchRight"
                  >查询</el-button
                >
              </el-col> -->
          <!-- <el-col :span="5">
                <el-button
                  class="ml10"
                  style="margin-top: 0px"
                  size="small"
                  @click="reset"
                  >重置</el-button
                >
              </el-col> -->
        </div>

        <div style="width: 100%; height: 90%; overflow: auto">
          <ul v-if="mode == 1 && leftList.length" class="reportList cursor">
            <li
              v-for="(item, index) in leftList"
              :key="index"
              :class="curIndex == index ? 'focus' : ''"
              @click="selectItem(null, index)"
              style="justify-content: space-between"
            >
              <div class="fl center label" :title="item.dictLabel">
                <!-- <span>{{ item.dictLabel }}</span> -->
                <span
                  v-if="
                    (nowEdit && item.dictValue == nowEdit) ||
                      item.dictValue == ''
                  "
                  ><el-input v-model="item.dictLabel" size="small"></el-input
                ></span>
                <!-- <span v-else-if="">{{ item.dictLabel }}</span> -->
                <span v-else>{{ item.dictLabel }}</span>

                <div class="f-right rigthBtn" v-if="!item.dictCode">
                  <el-button
                    type="primary"
                    style="margin-left: 20px"
                    @click="dictEdit(item)"
                    v-if="
                      (nowEdit && item.dictValue == nowEdit) || !item.dictValue
                    "
                    size="mini"
                    v-hasPermi="[
                      'fireArchivesInfo:fireArchivesInfo:editFireName',
                    ]"
                  >
                    保存
                  </el-button>
                  <el-button
                    type="warning"
                    style="margin-left: 20px; flex: 0"
                    @click.stop="dictEdit(item)"
                    v-else-if="item.dictValue"
                    v-hasPermi="[
                      'fireArchivesInfo:fireArchivesInfo:editFireName',
                    ]"
                    size="mini"
                  >
                    修改
                  </el-button>
                  <el-button
                    type="danger"
                    @click.stop="dictDel(item, index)"
                    size="mini"
                    v-hasPermi="['fireArchivesInfo:fireArchivesInfo:remove']"
                  >
                    删除
                  </el-button>
                </div>
                <div class="f-right rigthBtn" v-else>
                  <el-button
                    :type="item.involve == 1 ? 'warning' : 'info'"
                    style="margin-left: 20px; flex: 0"
                    @click="involved(item)"
                    v-if="item.involveId"
                    v-show="
                      !(
                        item.dictValue == 1 ||
                        item.dictValue == 2 ||
                        item.dictValue == 5
                      )
                    "
                    v-hasPermi="[
                      'fireArchivesInfo:fireArchivesInfo:updateInvolve',
                    ]"
                    size="mini"
                  >
                    {{ item.involve == 1 ? "不涉及" : "取消不涉及" }}
                  </el-button>
                </div>
              </div>
            </li>
            <li
              v-hasPermi="['fireArchivesInfo:fireArchivesInfo:add']"
              v-if="mode == 1"
            >
              <el-button
                v-hasPermi="['fireArchivesInfo:fireArchivesInfo:add']"
                @click="dictAdd"
                size="snall"
                type="primary"
                icon="el-icon-plus"
              ></el-button>
            </li>
          </ul>
          <ul class="reportList cursor" v-if="mode !== 1 && list.length">
            <li
              v-for="(item, index) in list"
              :key="index"
              v-if="list.length"
              :class="curIndex == index ? 'focus' : ''"
              @click="selectItem(item, index)"
            >
              <div class="fl label" :title="item.fireName">
                <span v-if="(nowEdit && nowEdit === item.id) || item.id == ''">
                  <el-input v-model="item.fireName" size="small"></el-input>
                </span>
                <span
                  v-else
                  style=" word-break: break-all; overflow-wrap: break-word;"
                  >{{ item.fireName }}</span
                >
              </div>
              <div class="f-right rigthBtn" v-if="mode !== 1">
                <el-button
                  type="primary"
                  style="margin-left: 20px"
                  @click="edit(item)"
                  v-if="(nowEdit && item.id == nowEdit) || !item.id"
                  size="mini"
                  v-hasPermi="[
                    'fireArchivesInfo:fireArchivesInfo:editFireName',
                  ]"
                >
                  保存
                </el-button>

                <el-button
                  type="warning"
                  style="margin-left: 20px; flex: 0"
                  @click="edit(item)"
                  v-else-if="item.id"
                  v-hasPermi="[
                    'fireArchivesInfo:fireArchivesInfo:editFireName',
                  ]"
                  size="mini"
                >
                  修改
                </el-button>

                <el-button
                  type="danger"
                  @click.stop="del(item, index)"
                  size="mini"
                  v-hasPermi="['fireArchivesInfo:fireArchivesInfo:remove']"
                >
                  删除
                </el-button>
              </div>
            </li>
            <li
              v-hasPermi="['fireArchivesInfo:fireArchivesInfo:add']"
              v-if="mode == 2"
            >
              <el-button
                v-hasPermi="['fireArchivesInfo:fireArchivesInfo:add']"
                @click="add"
                size="snall"
                type="primary"
                icon="el-icon-plus"
              ></el-button>
            </li>
          </ul>
        </div>
        <!-- {{playtype}} -->
      </div>
      <div class="content">
        <videoPlayer
          v-if="playtype == 1"
          style="height: 100%; width: 100%"
          ref="video"
        ></videoPlayer>
        <div
          class="flex center"
          style="width: 100%; height: 100%"
          v-else-if="playtype !== 1"
        >
          <!-- <img :src="url" v-if="playtype == 2" style="" alt="" /> -->
          <el-image
            v-if="playtype == 2"
            style="height: 100%"
            :src="url"
            :preview-src-list="[url]"
          />
          <!-- 'data:application/pdf;base64,' +  -->
          <iframe
            style="height: 100%; width: 100%"
            :src="url"
            v-else-if="playtype == 3"
            @click="fullScreen = true"
            frameborder="0"
          >
            <p>您的浏览器不支持 iframe 标签,请从列表中下载预览</p>
          </iframe>
          <div v-else class="nocontent">暂无内容</div>
        </div>
      </div>
      <div class="mt20" style="width: 20%">
        <!-- <div class="flex1"></div> -->
        <div
          class="ml10"
          v-if="
            ((leftList.length || list.length) &&
              ((leftList[curIndex] && leftList[curIndex].dictValue) ||
                (list[curIndex] && list[curIndex].id))) ||
              mode == 3
          "
        >
          <div
            class="mt10"
            v-hasPermi="['fireArchivesInfo:updateDrillInvolve']"
          >
            <el-button
              style="margin-right: 20px"
              :type="Dr.isInvolved == 1 ? 'warning' : 'info'"
              size="small"
              v-if="dictValue == 14"
              @click="involvedDr"
              :loading="Dr.isLoading"
            >
              {{ Dr.isInvolved == 1 ? "不涉及" : "取消不涉及" }}
            </el-button>
          </div>
          <div
            class="flex mt10"
            v-if="
              (mode == 1 && leftList[curIndex].customizeFlag == 0) ||
                !(mode == 2 && list[curIndex].remark)
            "
          >
            <el-button
              style="margin-right: 20px"
              type="success"
              size="small"
              v-if="
                mode == 1 &&
                  leftList[curIndex].customizeFlag == 0 &&
                  dictValue != 9
              "
              @click="down"
            >
              下载模板
            </el-button>

            <el-upload
              action="."
              :http-request="upload"
              accept="*"
              v-if="!(mode == 2 && list[curIndex].remark)"
              :before-upload="beforeUpload"
              :show-file-list="false"
              v-hasPermi="['fireArchivesInfo:fireArchivesInfo:add']"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <el-button
              style="margin-left: 20px"
              type="success"
              size="small"
              v-if="
                onlineAndOffline == 0 && !(mode == 2 && list[curIndex].remark)
              "
              @click="downFile"
            >
              下载文件
            </el-button>
          </div>
          <div class="mt10">
            <el-button
              style="margin-right: 20px"
              type="primary"
              size="small"
              @click="fullScreen = true"
              v-if="this.url"
            >
              弹窗显示
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :before-close="beforeClose"
      :visible.sync="fullScreen"
      :width="'80%'"
      ref="model"
      :close-on-click-modal="false"
    >
      <div class="content screenfull">
        <videoPlayer
          v-if="playtype == 1"
          style="height: 700px; width: 100%"
          ref="video"
        ></videoPlayer>
        <div
          class="flex center"
          style="width: 100%; height: 700px"
          v-else-if="playtype !== 1"
        >
          <img :src="url" v-if="playtype == 2" style="height: 100%" alt="" />
          <iframe
            style="height: 700px; width: 100%"
            :src="url"
            v-else-if="playtype == 3"
            frameborder="0"
          >
            <p>您的浏览器不支持 iframe 标签,请从列表中下载预览</p>
          </iframe>
          <div v-else class="nocontent">暂无内容</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { AIMarker } from "vue-picture-bd-marker";
// import crtmarker from "../../components/crtmarker";
// import CusPlayer from "../../components/CusPlayer.vue";
import OSS from "ali-oss";
import "xgplayer";
import videoPlayer from "../../../components/videoPlayr";

export default {
  props: ["dictValue", "dictType", "dict"],

  components: {
    videoPlayer,
  },
  data() {
    return {
      mode: 0, //模板类型 1: 带有二级菜单 且不可添加; 2 直接上传文件，可删除添加修改 ; 3:直接上传文件，不可添加 可删除修改
      fileList: {},
      leftList: [],
      fullScreen: false,
      status: "",
      isread: false,
      isUpload: false,
      id: this.$route.query.id,

      params: {
        page: 1,
        xm_uuid: this.$route.query.id,
      },
      nowEdit: null,
      list: [], // 摄像头列表
      count: 0,
      curIndex: 0,
      playtype: 0, // 1 视频 2图片 3pdf
      url: "",
      Dr: { isLoading: false, isInvolved: 1, companyNum: this.$route.query.id },
      playItem: {},
      playIndex: 0,
      base64res: "",
      onlineAndOffline: 0,
      downColumn: 0,
      //
    };
  },

  created() {
    this.onlineAndOffline = JSON.parse(
      localStorage.getItem("userInfo")
    ).isOnline; //0为离线（内网），1为在线（外网）
    console.log(this.onlineAndOffline, "this.onlineAndOffline");
    this.getLeftDict();

    // 查询报告类型

    // 获取单位

    // this.clearPoint(1)
  },
  methods: {
    //取消不涉及
    involved(item) {
      console.log(item);
      const params = {
        id: item.involveId,
        companyNum: this.$route.query.id,
        involve: item.involve == 0 ? 1 : 0,
      };
      this.$put(`/fireArchives/Archives/updateInvolve`, params).then((re) => {
        if (re.code == 200) {
          // this.$message.success(re.msg || "操作成功");
          this.$message({
            message: re.msg || "操作成功",
            type: "success",
            duration: 1000,
          });
          item.involve = item.involve == 0 ? 1 : 0;
          // this.clearAll();
          // this.getLeftDict();
        }
      });
    },
    // 不涉及消防队
    involvedDr() {
      this.Dr.isLoading = true;
      const params = {
        companyNum: this.Dr.companyNum,
        involve: this.Dr.isInvolved == 0 ? 1 : 0,
      };
      this.$put(`/fireArchives/Archives/updateDrillInvolve`, params).then(
        (res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg || "操作成功",
              type: "success",
              duration: 1000,
            });
            // this.$message.success(res.msg || "操作成功");
            this.Dr.isInvolved = params.involve;
            this.Dr.isLoading = false;
            // this.clearAll();
            // this.getLeftDict();
          }
        }
      );
    },
    getInvolvedDr(companyNum) {
      this.Dr.isLoading = true;
      const params = { companyNum };
      console.log(22222);
      this.$get(`/fireArchives/Archives/updateDrillInvolveState`, params).then(
        (res) => {
          if (res.code == 200) {
            console.log(res);
            this.Dr.isInvolved = res.data;
            this.Dr.companyNum = companyNum;
            this.Dr.isLoading = false;
            // this.clearAll();
            // this.getLeftDict();
          }
        }
      );
    },
    checkMod() {
      console.log(this.dictType, this.dictValue, "this.dict1");
      //模板类型 1: 带有二级菜单 且不可添加; 2 直接上传文件，可删除添加修改 ; 3:直接上传文件，不可添加 可删除修改
      var mode = this.mode;
      if (this.dict) {
        mode = 1;
      } else if (this.dictType == 1 && this.dictType == 2) {
        mode = 3;
      } else if (
        this.dictType == 1 &&
        (this.dictValue == 5 || this.dictValue == 9)
      ) {
        mode = 2;
      }
      this.mode = mode;
    },
    // 上传
    edit(it) {
      // 保存
      if (it == null) {
        return;
      }
      if (it.id && this.nowEdit !== it.id) {
        this.nowEdit = it.id;
      } else {
        this.save(it);
        console.log("save");
      }
    },
    // 编辑字典表
    dictEdit(it) {
      if (it == null) {
        return;
      }
      if (it.dictValue && this.nowEdit !== it.dictValue) {
        this.nowEdit = it.dictValue;
      } else {
        this.saveDict(it);
      }
    },
    dictAdd() {
      if (this.nowEdit && this.nowEdit.dictValue == "") {
        this.saveDict(this.nowEdit, true);

        return;
      }

      var obj = {
        dictLabel: "",
        dictValue: "",
        belongItem: 1,
        majorItem: this.dictValue,
        customizeFlag: 1,
        companyNum: this.$route.query.id || "",
      };
      this.leftList.push(obj);
    },
    dictDel(it, index) {
      if (it == null) {
        this.leftList.splice(index, 1);
        return;
      }
      if (!it.dictValue) {
        this.leftList.splice(index, 1);
        this.nowEdit = null;
        this.curIndex = this.curIndex - 1;
      } else {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            // console.log(it);
            var obj = it.dictValue
              ? {
                  id: it.dictValue,
                  companyNum: this.$route.query.id,
                  majorItem: this.dictValue,
                  belongItem: 1,
                }
              : null;
            this.$put(`/fireArchives/Archives/removeSmallItem`, obj).then(
              (re) => {
                if (re.code == 200) {
                  this.$message({
                    message: re.msg || "操作成功",
                    type: "success",
                    duration: 1000,
                  });
                  // this.$message.success(re.msg || "操作成功");
                  this.clearAll();
                  this.getLeftDict();
                }
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
            this.nowEdit = null;
          });
      }
    },

    saveDict(it, add) {
      // 修改

      if (it.dictValue) {
        it.belongItem = this.dictType;
        it.majorItem = this.dictValue;
        it.companyNum = this.$route.query.id || "";
      }

      this.$post("/fireArchives/Archives/addSmallItem", it).then((res) => {
        // this.getLeftDict()
        // this.$message({message: res.msg,type: "success", duration: 700,});
        this.$message({
          message: res.msg,
          type: "success",
          duration: 1000,
        });
        this.leftList.splice(this.curIndex, 1, res.data);
        this.nowEdit = null;
        if (add) {
          this.dictAdd();
        }
      });
    },

    // 保存
    save(it, add) {
      console.log(it);
      if (it.id) {
        // 修改

        var obj =
          this.dictValue == 6
            ? { eid: it.id, fireName: it.fireName }
            : { id: it.id, fireName: it.fireName };
        this.$post("fireArchives/Archives/editFireName", obj).then((res) => {
          // this.$message({message: res.msg,type: "success", duration: 700,});
          this.$message({
            message: res.msg,
            type: "success",
            duration: 1000,
          });
          this.nowEdit = null;
        });
      } else {
        this.$post("/fireArchives/Archives", it).then((res) => {
          // this.getLeftDict()
          // this.$message({message: res.msg,type: "success", duration: 700,});
          this.$message({
            message: res.msg,
            type: "success",
            duration: 1000,
          });
          this.list.splice(this.curIndex, 1, res.data);
          this.nowEdit = null;
          if (add) {
            this.add();
          }
        });
      }
    },
    add() {
      // if (this.mode == 1) {
      // 	if (this.leftList[this.leftList.length - 1].dictCode) this.leftList.push({});
      // 	return;
      // }
      if (this.nowEdit && this.nowEdit.id == "") {
        this.save(this.nowEdit, true);

        return;
      }
      var obj = {
        belongItem: this.dictType,
        companyNum: this.$route.query.id,
        createTime: "",
        delFlag: "",
        fireArchives: "",
        fireName: "",
        id: "",
        majorItem: this.dictValue,
        smallItem: "",
        remark: "",
        updateTime: "",
      };

      this.list.push(obj);

      this.nowEdit = obj;
    },
    clearAll() {
      this.leftList = [];
      this.list = [];
      this.url = "";
      this.playtype = 0;
      this.curIndex = 0;
      this.nowEdit = null;
    },
    selectItem(item, index) {
      if (this.curIndex == index) return false;
      this.curIndex = index;
      this.playtype = 0;
      this.url = "";
      if (this.$refs.video) {
        this.$refs.video.open = false;
      }

      if (
        item == null &&
        this.leftList[index]?.customizeFlag == 0 &&
        !this.leftList[index].dictCode
      ) {
        return;
      }
      if (
        item == null &&
        !this.leftList[index].dictValue &&
        this.leftList[index]?.customizeFlag == 1
      ) {
        return;
      }
      if (this.mode == 1) {
        // 如果有二级菜单

        this.getFiles();
      } else {
        this.play(this.list[this.curIndex], this.curIndex);
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 30MB!");
      }
      return isLt2M;
    },
    upload(val) {
      if (this.onlineAndOffline == 0) {
        if (
          !(
            val.file.name.indexOf("doc") > -1 ||
            val.file.name.indexOf("docx") > -1 ||
            val.file.name.indexOf("pdf") > -1 ||
            val.file.name.indexOf("jpg") > -1 ||
            val.file.name.indexOf("png") > -1 ||
            val.file.name.indexOf("jpeg") > -1
          )
        ) {
          this.$notify({
            title: "暂不支持该文件类型",
            // message: `${_this.fileList[id].name}上传完成`,
            type: "warning",
          });

          return;
        }
        console.log(val.file.name, "上传");
        let file = val.file;
        let id =
          // "/common/upload" +
          // // this.$config.dangan +
          // "/t" +
          Date.now() + "s" + file.size + "/" + file.name;
        this.$set(this.fileList, id, {
          name: file.name,
          size: file.size,
          uploading: true,
          time: 0,
          progress: 0,
          key: id,
          url: "",
          // client: client,
        });
        // log(this.fileList,'111111111111111111111')

        let formData = new FormData();
        // console.log(formData, "formData");
        formData.append("file", file);
        // console.log(formData, "formData1");
        // formData.append("title", this.title);
        // this.getTimes(file, id);
        // console.log(file, "file");

        this.$post("/common/upload", formData).then((res) => {
          this.fileList[id].progress = 100;
          this.fileList[id].uploading = false;
          this.fileList[id].url = res.data.url;
          let url;
          let par;

          if (this.mode == 1 || this.mode == 3) {
            //         // 如果是消防管理制度、灭火应急疏散、消防安全管理。走直接上传
            url = "/fireArchives/Archives";
            par = {
              belongItem: this.dictType,
              companyNum: this.$route.query.id,
              fireArchives: this.fileList[id].url,
              fireName: this.fileList[id].name,
              customizeFlag: this.leftList.length
                ? this.leftList[this.curIndex].customizeFlag
                : 0,
              majorItem: this.dictValue,
              smallItem: this.leftList.length
                ? this.leftList[this.curIndex].dictValue
                : "",
              // sleftitem : _this.leftList[_this.curIndex].customizeFlag==1 ? '' : '',
            };
            // console.log(par,'par');
          } else {
            url = "/fireArchives/Archives/upload";
            par = {
              id: this.list[this.curIndex].id,
              fireArchives: this.fileList[id].url,
              fireName: this.fileList[id].name,
            };
          }

          this.$post(url, par).then((result) => {
            // console.log(result, "result");
            this.playItem = result.data;

            this.play(this.playItem, this.playIndex);
            // _this.$notify({
            //   title: "上传成功",
            //   message: `${_this.fileList[id].name}上传完成`,
            //   type: "success",
            // });
          });
          setTimeout(() => {
            if (!this.dict) {
              console.log("zoulem");
              this.getLeftDict();
            } else {
              console.log(this.playItem, this.playIndex, "playItem,playIndex");

              this.selectItem(null, this.curIndex);
              if ("fire_legality_materials" == this.dict) this.getLeftDict();
            }
          }, 500);
          this.$notify({
            title: "上传成功",
            message: `${this.fileList[id].name}上传完成`,
            type: "success",
          });
        });
      } else {
        console.log("在线");
        if (
          !(
            val.file.name.toLowerCase().indexOf("doc") > -1 ||
            val.file.name.toLowerCase().indexOf("pdf") > -1 ||
            val.file.name.toLowerCase().indexOf("jpg") > -1 ||
            val.file.name.toLowerCase().indexOf("png") > -1 ||
            val.file.name.toLowerCase().indexOf("jpeg") > -1 ||
            val.file.name.toLowerCase().indexOf("xls") > -1
          )
        ) {
          this.$notify({
            title: "暂不支持该文件类型",
            // message: `${_this.fileList[id].name}上传完成`,
            type: "warning",
          });

          return;
        }
        let client = new OSS(this.$store.state.config.ossConfig);
        let file = val.file;
        let _this = this;
        let id =
          this.$config.dangan +
          "/t" +
          Date.now() +
          "s" +
          file.size +
          "/" +
          file.name;
        this.$set(this.fileList, id, {
          name: file.name,
          size: file.size,
          uploading: true,
          time: 0,
          progress: 0,
          key: id,
          client: client,
        });
        // 定义上传方法。
        function multipartUpload() {
          _this.fileList[id].client
            .multipartUpload(id, file, {
              checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
              progress: (p, checkpoint, res) => {
                //log(p,checkpoint,res)
                if (checkpoint) {
                  _this.fileList[id].progress = p * 100;
                  _this.fileList[id].data = checkpoint;
                }
              },
              partSize: 1000 * 1024, //设置分片大小
              timeout: 120000, //设置超时时间
              mime: val.type,
            })
            .then((res) => {
              _this.fileList[id].progress = 100;
              _this.fileList[id].uploading = false;
              console.log(res);
              var url = null;
              var par = {};
              console.log(_this.mode, 33333333);
              if (_this.mode == 1 || _this.mode == 3) {
                // 如果是消防管理制度、灭火应急疏散、消防安全管理。走直接上传
                url = "/fireArchives/Archives";
                par = {
                  belongItem: _this.dictType,
                  companyNum: _this.$route.query.id,
                  fireArchives: _this.fileList[id].key,
                  fireName: _this.fileList[id].name,
                  customizeFlag: _this.leftList.length
                    ? _this.leftList[_this.curIndex].customizeFlag
                    : 0,
                  majorItem: _this.dictValue,
                  smallItem: _this.leftList.length
                    ? _this.leftList[_this.curIndex].dictValue
                    : "",
                  // sleftitem : _this.leftList[_this.curIndex].customizeFlag==1 ? '' : '',
                };
              } else {
                url = "/fireArchives/Archives/upload";
                par = {
                  id: _this.list[_this.curIndex].id,
                  fireArchives: _this.fileList[id].key,
                  fireName: _this.fileList[id].name,
                };
              }

              _this.$post(url, par).then((result) => {
                _this.$notify({
                  title: "上传成功",
                  message: `${_this.fileList[id].name}上传完成`,
                  type: "success",
                });

                //  _this.play(null,_this.curIndex)
                if (!_this.dict) {
                  _this.getLeftDict();
                } else {
                  _this.selectItem(null, _this.curIndex);
                  if ("fire_legality_materials" == _this.dict)
                    _this.getLeftDict();
                }
              });
            })
            .catch((err) => {
              if (
                err.code == "RequestError" ||
                err.code == "ConnectionTimeoutError"
              ) {
                //网络错误或超时
                setTimeout(multipartUpload, 3000);
              }
            });
        }

        multipartUpload();
      }
    },
    // 提交上传
    formSubmit() {
      let _this = this;
      var arr = [];
      for (let key in this.fileList) {
        console.log(key);
        let data = this.fileList[key];
        arr.push({
          wj_name: data.name,
          wj_lujing: key,
        });
      }

      var obj = {
        xm_uuid: this.$route.query.id,
        wenjianbg: arr,
      };
      this.$post("/dzda/addwenjian", obj).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg || "操作成功",
            type: "success",
            duration: 1000,
          });
        }
        // this.$message.success(res.msg || "操作成功");
        this.showDia = false;
        this.cancleUpload();
        this.getList();
      });
    },

    cancleUpload() {
      this.fileList = {};
      this.form = {
        basebg: {
          bg_company_num: "",
        },
        xiangmubg: {
          xm_baogao_name: "",
          xm_baogao_leixing: "",
          xm_suoshu: "",
          xm_jiancha_user: "",
        },
        wenjianbg: [],
      };
    },
    beforeClose(done) {
      if (this.isUpload) {
        this.$confirm("文件上传中，关闭将取消上传，是否取消", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            done();
            this.cancleUpload();
          })
          .catch(() => {});
      } else {
        done();
      }
    },
    del(it, index) {
      if (it == null) {
        this.leftList.splice(index, 1);
        return;
      }
      if (!it.id && !it.eid) {
        this.list.splice(index, 1);
        this.nowEdit = null;
        this.curIndex = this.curIndex - 1;
      } else {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            console.log(it);
            var obj = it.eid ? { eid: it.eid } : { id: it.id };
            this.$put(`/fireArchives/Archives/remove`, obj).then((re) => {
              if (re.code == 200) {
                // this.$message.success(re.msg || "操作成功");
                this.$message({
                  message: re.msg || "操作成功",
                  type: "success",
                  duration: 1000,
                });
                this.clearAll();
                this.getLeftDict();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
            this.nowEdit = null;
          });
      }
    },
    getLeftDict(ONLY) {
      this.leftList = [];
      this.checkMod();
      console.log(this.mode, "mode");
      if (this.mode == 1) {
        this.$get("/system/dict/data/notPageList/", {
          dictType: this.dict,
          involve: this.$route.query.id,
        }).then((res) => {
          console.log(res, "resmode == 1");
          var list = res.data;

          this.$get("/fireArchives/Archives/addSmallItemList", {
            companyNum: this.$route.query.id,
            majorItem: this.dictValue,
          }).then((RES) => {
            log(RES, "addSmallItemList");
            var list1 = list.concat(RES.data);
            this.leftList = list1;
            if (ONLY) return;
            this.getFiles();
          });

          // this.play(null,this.curIndex)
        });
      } else {
        log("getFiles");
        this.getFiles();
      }
    },
    getFiles() {
      console.log("getFiles", this.fileList);
      this.$get("/fireArchives/Archives/list", {
        belongItem: this.dictType,
        companyNum: this.$route.query.id,
        majorItem: this.dictValue,
        smallItem: this.leftList.length
          ? this.leftList[this.curIndex].dictValue
          : "",
        customizeFlag: this.leftList.length
          ? this.leftList[this.curIndex].customizeFlag
          : 1,
      }).then((res) => {
        console.log(res, 3333);
        this.list = res.data;
        // console.log(res.data, "list");
        // setTimeout(() => {

        //   this.curIndex = 0
        // })
        // if(this.dictValue==6){
        //   this.list.map(item=>{
        //     item.id=item.eid
        //   })
        // }
        if (this.list.length) {
          if (this.mode == 1) {
            this.play(this.list[0], this.curIndex);
          } else {
            console.log(this.list);
            this.play(this.list[this.curIndex], this.curIndex);
          }
        }
      });
    },
    pageChange(val) {
      // console.log(val)
      this.params.page = val;
      this.getList();
    },
    // 报告新增

    play(item, index) {
      if (this.onlineAndOffline == 0) {
        this.playItem = item;
        this.playIndex = index;
        if (item.fireArchives == null) {
          return;
        }
        console.log(item, index, "item, index");
        this.$get("/common/download/resource", {
          url: item.fireArchives,
          // responseType: "blob",
          // headers: {
          //   "type": 'application/pdf'
          // },
        }).then((res) => {
          // console.log(res, "res");
          this.base64res = res;
          if (item.id || item.eid) {
            var name =
              item.fireArchives.indexOf(".") > -1
                ? item.fireArchives
                : item.fireName;
            var type = "";
            let client = new OSS(this.$store.state.config.ossConfig);
            console.log(item.fireArchives.indexOf("http") > -1);

            if (item.fireArchives.indexOf("http") > -1) {
              console.log("zou");
              this.url = item.fireArchives;
            } else {
              this.url = client.signatureUrl(item.fireArchives);
            }

            if (/^.*\..*$/.test(name)) {
              type = name.split(".")[name.split(".").length - 1];
            }

            type = type.toUpperCase();

            if (this.$store.state.videoType.indexOf(type) > -1) {
              this.playtype = 1;
              setTimeout(() => {
                this.$refs.video.open = true;
                this.$refs.video.getDownUrl(
                  item.fireArchives,
                  null,
                  type,
                  item.tr_length || ""
                );
              }, 1);
            } else if (this.$store.state.pictureType.indexOf(type) > -1) {
              this.playtype = 2;

              if (this.$refs.video) this.$refs.video.open = false;
            } else if (type == "PDF") {
              this.playtype = 3;

              const pdfBase64 = res;
              const arrayBuffer = Uint8Array.from(atob(pdfBase64), (c) =>
                c.charCodeAt(0)
              ).buffer;
              const blob = new Blob([arrayBuffer], { type: "application/pdf" });
              const url = URL.createObjectURL(blob);
              console.log(url, "url");
              this.url = url;

              if (this.$refs.video) this.$refs.video.open = false;
            } else if (type.toLowerCase().indexOf("doc") > -1) {
              this.playtype = 3;
              console.log("出发了吗");
              // const blob = new Blob([res], { type: 'application/pdf' }
              // base64;
              const pdfBase64 = res;
              const arrayBuffer = Uint8Array.from(atob(pdfBase64), (c) =>
                c.charCodeAt(0)
              ).buffer;
              const blob = new Blob([arrayBuffer], { type: "application/pdf" });
              const url = URL.createObjectURL(blob);
              console.log(url, "url");
              this.url = url;
              //文件流 但是有问题
              // const binaryData = [];
              // binaryData.push(res);
              // const url = window.URL.createObjectURL(
              //   new Blob(binaryData, { type: "application/pdf;chartset=UTF-8" })
              // );
              // console.log(url, "url");

              //  this.url = window.HT_EnvConfig.fyptUrl + `/static/pdfjs/web/viewer.html?file=` + url

              // var url = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
              //   this.url
              // )}`;
              // var url = item.fireArchives
              // this.url = res
              // window.open(url);
              // console.log(this.url,'this.url');
            }

            if (this.dictValue == 14) {
              this.getInvolvedDr(item?.companyNum);
            }
          }
        });
      } else {
        if (item.id || item.eid) {
          var name =
            item.fireArchives.indexOf(".") > -1
              ? item.fireArchives
              : item.fireName;
          var type = "";
          let client = new OSS(this.$store.state.config.ossConfig);
          console.log(item.fireArchives.indexOf("http") > -1);

          if (item.fireArchives.indexOf("http") > -1) {
            this.url = item.fireArchives;
          } else {
            this.url = client.signatureUrl(item.fireArchives);
          }
          console.log(this.url, "1111111111111111");
          if (/^.*\..*$/.test(name)) {
            type = name.split(".")[name.split(".").length - 1];
          }

          type = type.toUpperCase();
          console.log(type.toLowerCase(), 4444444444444444);
          if (this.$store.state.videoType.indexOf(type) > -1) {
            this.playtype = 1;
            setTimeout(() => {
              this.$refs.video.open = true;
              this.$refs.video.getDownUrl(
                item.fireArchives,
                null,
                type,
                item.tr_length || ""
              );
            }, 1);
          } else if (this.$store.state.pictureType.indexOf(type) > -1) {
            this.playtype = 2;

            if (this.$refs.video) this.$refs.video.open = false;
          } else if (type == "PDF") {
            console.log(333333333333);
            this.playtype = 3;
            if (this.$refs.video) this.$refs.video.open = false;
          } else if (type.toLowerCase().indexOf("doc") > -1) {
            this.playtype = 3;

            var url = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
              this.url
            )}`;
            this.url = url;
          } else if (type.toLowerCase().indexOf("xls") > -1) {
            this.playtype = 3;
            var url = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
              this.url
            )}`;
            this.url = url;
          }

          if (this.dictValue == 14) {
            this.getInvolvedDr(item?.companyNum);
          }
        }
      }
    },

    down() {
      log("我是下载", this.dictType);
      this.$get("/fireArchives/Archives/download", {
        smallItem: this.leftList[this.curIndex].dictValue,
        remark: this.leftList[this.curIndex].dictType,
      }).then((res) => {
        console.log(res, "res");
        window.location = res.msg;
      });
    },
    downFile() {
      this.downColumn = this.dictType;
      log("我是下载wenjian", this.leftList, this.curIndex);

      //   内网
      if (this.downColumn == 1) {
        // let image=new Image()
        if (this.list[0].fireArchives.indexOf("png") > -1) {
          this.imageChangeUpload();
        } else if (this.list[0].fireArchives.indexOf("jpg") > -1) {
          this.imageChangeUpload();
        } else if (this.list[0].fireArchives.indexOf("jpeg") > -1) {
          this.imageChangeUpload();
        } else {
          console.log(this.list, "this.list[0].fireArchives");
          //   window.location.href = this.list[0].fireArchives;
        }
      } else {
        // let image=new Image()
        if (this.list[this.curIndex].fireArchives.indexOf("png") > -1) {
          this.imageChangeUpload();
        } else if (this.list[this.curIndex].fireArchives.indexOf("jpg") > -1) {
          this.imageChangeUpload();
        } else if (this.list[this.curIndex].fireArchives.indexOf("jpeg") > -1) {
          this.imageChangeUpload();
        } else {
          //   window.location.href = this.list[this.curIndex].fireArchives;
        }
      }
    },
    // 搜素单位
    // 图片转换下载代码
    imageChangeUpload() {
      console.log("代码");
      let base64Str = "data:image/jpeg;base64," + this.base64res;
      let aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = base64Str;
      aLink.download = this.list[this.curIndex].fireName;
      // 触发点击-然后移除
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    },
    //提交
    submit() {
      // return
      // if(this.form.point_uuid){
      //   var obj = {
      //     point_uuid:this.form.point_uuid,
      //     x_axis:this.form.position.x,
      //     xa_axis:this.form.position.x1,
      //     y_axis:this.form.position.y,
      //     ya_axis:this.form.position.y1
      //     }
      //     this.$post('crt/crtupdatedot',obj).then(res=>{
      //       this.$message.success('标点成功')
      //       this.form={}
      //       this.isdraged = !this.isdraged
      //       this.selectPoint=false
      //     })
      // }else{
      //   this.isdraged = !this.isdraged
      // }
    },
  },
  watch: {
    dictValue(v) {
      this.clearAll();
      this.getLeftDict();
    },
    dictType(val) {},
  },
};
</script>

<style lang="scss" scoped>
.file-list {
  li {
    position: relative;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;

    img {
      width: 75px;
      margin-right: 15px;
    }

    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 8px;
      cursor: pointer;
    }
  }
}

.intro {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  text-align: center;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mb5 {
  margin-bottom: 5px;
}

.screenfull {
  min-height: 800px;
}

.ml20 {
  margin-left: 20px;
}

.mt10 {
  margin-top: 10px !important;
}

.selectVideo {
  border: solid 2px red;
  height: 500px;
  width: 600px;
  position: relative;
}

.focus {
  background: #3d62de;
  color: #fff;
}

.rigthBtn {
  height: 100%;
  align-items: center;
  display: flex;
  align-self: center;
}

.nocontent {
  font-size: 30px;
  color: #eee;
}

.reportList {
  width: 99%;
  height: 100%;

  li {
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #c1c1c1;
  }
}

::v-deep .selected {
  z-index: 99999;
}

::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}

::v-deep .g-image-op-del {
  display: none;
}

::v-deep .g-image-op-content {
  height: auto;
}

::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}

.canvas {
  display: flex;
  align-items: center;
}

.container {
  height: 90%;
  flex: 1;
  width: 100%;
  flex-direction: column;

  .topnav {
    height: 20%;
  }

  .leftNav {
    height: 100%;
    max-width: 23%;
  }

  #test {
    border-top: 1px solid #ddd;

    height: 100%;

    .el-dialog__body {
      padding: 10px 20px !important;
    }

    .label {
      display: flex;
      width: 100%;
    }

    .content {
      width: 74%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      overflow: hidden;
      position: relative;
      border: 1px solid gray;
    }
  }
}
</style>
